import { useMutationHook, useQueryHook } from "@/hooks"
import {
  createCoach,
  joinCoach,
  readTeamCoachList,
  upsertCoach,
  upsertCoachLeave,
} from "@/app/api/coach"

export const useTeamCoachListQuery = () => {
  return useQueryHook({
    queryKey: ["readTeamCoachList"],
    queryFn: readTeamCoachList,
  })
}

export const useUpsertCoachMutation = () => {
  return useMutationHook(upsertCoach, [["readAccountInfo"], ["readTeamCoachList"]])
}

export const useUpsertCoachLeaveMutation = () => {
  return useMutationHook(upsertCoachLeave, [["readAccountInfo"], ["readTeamCoachList"]])
}

export const useCreateCoachMutation = () => {
  return useMutationHook(createCoach, [["readAccountInfo"], ["readTeamCoachList"]])
}

export const useJoinCoachMutation = () => {
  return useMutationHook(joinCoach, [["readAccountInfo"], ["readTeamCoachList"]])
}
